import { AppImages, navigation, React, variantProvider } from '@/app'
import { Button, Image, Text, View } from '@/components'
import { modal, ModalParams } from '@codeleap/modals'

function Content(props: ModalParams) {
  const { toggle } = props

  const handleStartLearning = () => {
    toggle()
    navigation.navigate('Learn.MyJourney')
  }

  return (
    <View style={styles.border}>
      <Image source={AppImages.personaCelebration} style={styles.image} />

      <View variants={['padding:3', 'gap:2', 'column']}>
        <Text variants={['h3', 'textCenter']} text="Your personalised learning journey is ready!" />

        <Button
          text="Start learning"
          debugName="open-onboarding-lesson"
          onPress={handleStartLearning}
          style={styles.button}
        />
      </View>
    </View>
  )
}

const styles = variantProvider.createComponentStyle(
  t => ({
    image: {
      borderTopLeftRadius: 32,
      borderTopRightRadius: 32
    },
    border: {
      borderRadius: 32,
      ...t.presets.column
    },
    button: {
      height: 48
    }
  }),
  true
)

export const SuccessPersonaSelected = modal()
  .content(props => <Content {...props} />)
  .props({ variants: ['noPadding'], styles: { box: styles.border }, closable: false })
